/* eslint-disable no-nested-ternary */
import { FC, useCallback, useState } from 'react'
import { Table, Toolbar } from 'shared'
import { useNavigate } from 'react-router'
import './wallet.scss'
import TransactionStatusCell from 'shared/molecules/table/cells/TransactionStatusCell'
import { SortType } from 'rsuite-table'
import { IFilter, Operator } from 'api/types'
import { ActionCell, DateTimeCell } from 'shared/molecules/table/cells'
import TransactionTypeCell from 'shared/molecules/table/cells/TransactionTypeCell'
import AmountCell from 'shared/molecules/table/cells/AmountCell'
import useAuth from '../../../hooks/Auth'
import { useTableHandlers } from '../../../hooks/useTableHandlers'
import { wallet, WalletListRequest } from '../types'
import { useFetchBillingListQuery } from '../walletApiSlice'
import { formatDateToISO } from '../utils'

const { Column, HeaderCell, Cell } = Table

const Walletcolumns = [
  { key: 'TransactionId', label: 'Transaction ID', width: 150 },
  { key: 'campaignName', label: 'Compaign Name', width: 150 },
  { key: 'amount', label: 'Amount', width: 150 },
  { key: 'transactionType', label: 'Transaction Type', width: 150 },
  { key: 'channel', label: 'Channel-Type', width: 150 },
  { key: 'status', label: 'Status', width: 150 }
]

const ViewTransaction: FC = () => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<string>()
  const { loginUserDetails } = useAuth()

  const subsId = loginUserDetails?.companyDTO?.subsId

  const {
    requestBody,
    onPageChange,
    onSortColumn,
    onSearchChange,
    onFilterChange
  } = useTableHandlers<wallet, WalletListRequest>(
    {
      filters: [
        {
          fieldName: 'status',
          operator: Operator.EQ,
          fieldValue: activeTab
        },
        {
          fieldName: 'subsId',
          operator: Operator.EQ,
          fieldValue: subsId
        }
      ],
      page: { size: 10, number: 1 }
    },
    'name'
  )
  const handleSortColumn = useCallback(
    (column: string, type?: SortType) => {
      onSortColumn(column, type)
    },
    [onSortColumn]
  )

  const { data: TransactionData, isFetching } =
    useFetchBillingListQuery(requestBody)

  const flattenedData =
    TransactionData?.content?.map((item) => ({
      amount: item.amount,
      campaignName: (item.campaign as { name?: string })?.name || '-',
      createdDate: item.createdDate,
      transactionType: item.transactionType,
      status: item.status,
      channel: (item.campaign as { channel?: string })?.channel || '-'
    })) || []

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)

    const newFilters: IFilter<wallet>[] = [
      {
        fieldName: 'status',
        operator: Operator.EQ,
        fieldValue: tab
      },
      {
        fieldName: 'subsId',
        operator: Operator.EQ,
        fieldValue: subsId
      }
    ]

    onFilterChange(newFilters)
  }

  const total = TransactionData?.totalElements
  const handleAction = () => {
    navigate('/wallet')
  }

  const handleDateRangeSelect = (range: [Date | null, Date | null] | null) => {
    if (range && range[0] && range[1]) {
      const startDate = formatDateToISO(range[0])
      const endDate = formatDateToISO(range[1])

      onFilterChange([
        {
          fieldName: 'startDate',
          operator: Operator.GTE,
          fieldValue: startDate
        },
        { fieldName: 'endDate', operator: Operator.LTE, fieldValue: endDate },
        {
          fieldName: 'subsId',
          operator: Operator.EQ,
          fieldValue: subsId
        }
      ])
    } else {
      onFilterChange([])
    }
  }

  const handleDownloadAction = (
    eventKey: string | undefined,
    rowData: wallet
  ) => {
    switch (eventKey) {
      case '7':
        break
      default:
        break
    }
  }
  const options = [
    {
      label: 'All',
      value: '',
      onClick: () => handleTabChange('')
    },
    {
      label: 'Completed',
      value: 'transactionStatus.COMPLETED',
      onClick: () => handleTabChange('COMPLETED')
    },
    {
      label: 'Failed',
      value: 'transactionStatus.FAILED',
      onClick: () => handleTabChange('FAILED')
    }
  ]
  return (
    <div>
      <Toolbar
        backButtonClick={handleAction}
        backButton="Back"
        total={total}
        options={options}
        onSearchChange={onSearchChange}
        onDateRangeSelect={handleDateRangeSelect}
      />
      <div className="list__main-container">
        <Table
          data={flattenedData || []}
          loading={isFetching}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={TransactionData?.totalElements ?? 10}
          onSortColumn={handleSortColumn}
          onPageChange={onPageChange}
        >
          {Walletcolumns.map(({ key, label }, index) => (
            <Column
              flexGrow={1}
              key={key}
              align={index === 0 ? 'left' : 'center'}
              sortable
            >
              <HeaderCell>{label}</HeaderCell>
              {key === 'status' ? (
                <TransactionStatusCell dataKey={key} />
              ) : key === 'transactionType' ? (
                <TransactionTypeCell dataKey={key} />
              ) : key === 'amount' ? (
                <AmountCell dataKey={key} />
              ) : (
                <Cell dataKey={key} />
              )}
            </Column>
          ))}
          <Column flexGrow={1}>
            <HeaderCell>Date</HeaderCell>
            <DateTimeCell dataKey="createdDate" format="dd/MMM/yy, h:mm a" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>Action</HeaderCell>
            <ActionCell
              dataKey="action"
              onAction={handleDownloadAction}
              actionOptions={['Download Transaction']}
            />
          </Column>
        </Table>
      </div>
    </div>
  )
}
export default ViewTransaction
